import React from 'react';
import { Field } from '../configuration';

export interface InformationProps {
  field: Field
}

export default function Information({ field }: InformationProps) {
  return (
    <p className=" text-novartis-font" dangerouslySetInnerHTML={{ __html: field.label }} />
  );

}
